module.exports = __webpack_public_path__ + "img/1F1E7-1F1F8.6b69c95e.svg";